<script>
  import { getContext } from 'svelte'

  export let fields = {}

  const platform = getContext('platform')

  let selectedItem = null
  let menuOpen = false

  platform.router.before(() => {
    selectedItem = null
    menuOpen = false
  })
</script>

<div class="menu">
  <div class="menu-items">
    {#each fields.menuItems as item, i (item.id)}
      <div class="item">
        <svelte:element this={item.link ? 'a' : 'div'} href={item.link} class="item-container">
          <span>{item.label}</span>
          {#if item?.children?.length > 0}
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000">
              <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
            </svg>
            <svg height="50" width="200" xmlns="http://www.w3.org/2000/svg" class="safezone-left">
              <polygon points="0,50 200,50 200,0" style="fill: transparent" class="safezone-hitbox" />
            </svg>
            <svg height="50" width="200" xmlns="http://www.w3.org/2000/svg" class="safezone-right">
              <polygon points="0,50 200,50 0,0" style="fill: transparent" class="safezone-hitbox" />
            </svg>
          {/if}
        </svelte:element>
        {#if item?.children?.length > 0}
          <div class="dropdown">
            <h3>{item.label}</h3>
            <div class="dropdown-items">
              {#each item.children as child (child.id)}
                <a class="child" href={child.link}>
                  <span>{child.label}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/>
                  </svg>
                </a>
              {/each}
            </div>
          </div>
        {/if}
      </div>
    {/each}
  </div>
  <div class="mobile-menu">
    <input type="checkbox" id="menu-toggle" class="menu-toggle" bind:checked={menuOpen} />
    <label for="menu-toggle" class="menu-trigger">
      <div class="open-menu">
        <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#fff8f4">
          <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/>
        </svg>
      </div>
      <div class="close-menu">
        <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#fff8f4">
          <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
        </svg>
      </div>
    </label>
    <div class="mobile-menu-container">
      <div class="mobile-menu-items">
        {#each fields.menuItems as item}
          <svelte:element
            this={item.children.length ? 'div' : 'a'}
            href={item.link}
            class="mobile-item"
            role={item.children.length ? 'button' : 'link'}
            on:click={() => {
              if (item.children.length) {
                selectedItem = item
              }
            }}
          >
            <div>{item.label}</div>
            {#if item.children.length}
              <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#000000"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>
            {/if}
          </svelte:element>
        {/each}
      </div>
      <div class="contact-info">
        <a href="/live-in-care" class="jolojo-cms-button">
          <button class="jolojo-custom-button-style__yellow">Looking for care?</button>
        </a>
        <a href="tel:01732443197" style="color: var(--white); margin: 8px 0 16px;">Call 01732 443197</a>
        <a href="/live-in-care-jobs" class="jolojo-cms-button">
          <button class="jolojo-custom-button-style__peach">Become a carer?</button>
        </a>
        <a href="tel:01732443197" style="color: var(--white); margin: 8px 0 16px;">Call 01732 443197</a>
        <a href="https://connect.consultuscare.com" target="_blank" class="jolojo-menu-connect">
          <svg xmlns="http://www.w3.org/2000/svg" width="28.787" height="28.787" viewBox="0 0 28.787 28.787">
            <defs>
              <clipPath id="clip-path">
                <rect id="Rectangle_3844" data-name="Rectangle 3844" width="28.787" height="28.787" transform="translate(0)" fill="rgba(0,0,0,0)" stroke="currentColor" stroke-width="1" />
              </clipPath>
            </defs>
            <g id="Group_3541" data-name="Group 3541" transform="translate(2 3)">
              <g id="Group_3302" data-name="Group 3302" transform="translate(-2 -3)" clip-path="url(#clip-path)">
                <path id="Path_18351" data-name="Path 18351" d="M12.159,0A12.159,12.159,0,1,1,0,12.159,12.159,12.159,0,0,1,12.159,0Z" transform="translate(1.901 2.568)" fill="rgba(0,0,0,0)" stroke="currentColor" stroke-linecap="round" stroke-width="2" />
                <ellipse id="Ellipse_113" data-name="Ellipse 113" cx="4.678" cy="4.678" rx="4.678" ry="4.678" transform="translate(9.382 7.39)" fill="none" stroke="currentColor" stroke-linecap="round"stroke-width="2" />
                <path id="Path_18330" data-name="Path 18330" d="M9.482,33.356a7.35,7.35,0,1,1,14.7,0" transform="translate(-2.772 -9.26)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" />
              </g>
            </g>
          </svg>
          <p>Connect App</p>
        </a>
      </div>
      {#if selectedItem}
        <div class="mobile-child-items-container">
          <div class="mobile-child-header">
            <button class="back-icon" on:click={() => { selectedItem = null }} style="color: var(--dark-green)">
              <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="currentColor"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>
            </button>
            <div>{selectedItem.label}</div>
          </div>
          <div class="mobile-child-items">
            {#each selectedItem.children as item}
              <a href={item.link}>
                {item.label}
              </a>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>

<style lang="scss">.mobile-menu {
  position: relative;
}
@media screen and (min-width: 1440px) {
  .mobile-menu {
    display: none;
  }
}

.menu-toggle {
  display: none;
}

.menu-trigger {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.open-menu {
  display: block;
}

.close-menu {
  display: none;
}

.menu-toggle:checked + .menu-trigger .open-menu {
  display: none;
}

.menu-toggle:checked + .menu-trigger .close-menu {
  display: block;
}

.mobile-menu-container {
  display: none;
  height: calc(100dvh - 90px);
  background-color: var(--dark-green);
}

.contact-info {
  background-color: var(--dark-green);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}
.contact-info p {
  color: white;
}

.menu-toggle:checked ~ .mobile-menu-container {
  display: block;
  position: fixed;
  width: 100%;
  left: 0;
  top: 90px;
  max-height: calc(100dvh - 90px);
  overflow-y: auto;
}

.mobile-menu-items {
  background-color: var(--light-pink);
  padding: 2rem;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.mobile-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  height: 35px;
}

.mobile-child-items-container {
  height: calc(100% - 90px);
  width: 100%;
  position: fixed;
  top: 90px;
  background-color: var(--cream);
}

.mobile-child-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: var(--dark-green);
  font-weight: bold;
  font-size: 20px;
}

.mobile-child-items {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  font-weight: bold;
}

.menu-items {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  justify-content: space-between;
}
@media screen and (max-width: 1440px) {
  .menu-items {
    display: none;
  }
}

.item {
  height: 90px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.item-container {
  padding: 0.5rem 1rem;
  text-decoration: none;
  position: relative;
}
.item-container .safezone-left {
  position: absolute;
  bottom: -30px;
  left: -200px;
  display: none;
  pointer-events: none;
  z-index: 5;
}
.item-container .safezone-left .safezone-hitbox {
  pointer-events: auto;
}
.item-container .safezone-right {
  position: absolute;
  bottom: -30px;
  left: 100%;
  display: none;
  pointer-events: none;
  z-index: 5;
}
.item-container .safezone-right .safezone-hitbox {
  pointer-events: auto;
}

.item:hover .item-container {
  background: white;
  border-radius: 2rem;
}
.item:hover .item-container .safezone-left,
.item:hover .item-container .safezone-right {
  display: block;
}

.item:hover .dropdown {
  display: flex;
}

.dropdown {
  display: none;
  position: absolute;
  gap: 1rem;
  top: 100%;
  left: 0;
  width: 100%;
  justify-content: space-between;
  min-height: 90px;
  padding: 2rem 1rem;
  box-shadow: 0 2px 0 var(--dark-green);
}
.dropdown::before {
  content: "";
  position: absolute;
  top: 0px;
  right: 100%;
  height: 100%;
  box-shadow: 0 2px 0 var(--dark-green);
}
.dropdown::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 100%;
  height: 100%;
  box-shadow: 0 2px 0 var(--dark-green);
}
.dropdown h3 {
  line-height: 0.9;
  color: var(--dark-green);
}
.dropdown svg {
  fill: var(--dark-green);
}

.dropdown-items {
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 2rem 3rem;
}
@media (max-width: 1200px) {
  .dropdown-items {
    grid-template-columns: auto auto;
  }
}

.back-icon {
  background-color: var(--yellow);
  border: none;
  padding: 10px;
  cursor: pointer;
}

.jolojo-menu-connect {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  color: var(--white);
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>